var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center"},[_c('img',{staticClass:"h-10 w-10 object-contain",attrs:{"src":require("@/assets/loader.gif"),"alt":"Loading"}})])
}]

export { render, staticRenderFns }